import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import Transactions from "./TransactionMain";
import TransactionType from "./TransactionTypes";
import TransactionMode from "./TransactionModes";
import NFOAndNewPurchaseDigital from "./nfoAndNewPurchase";
import Nominee from "../UpdateNominee/index";
import UpdateNomineeEdit from "../UpdateNominee/update-nominee-edit";
import UpdateNomineeSuccess from "../UpdateNominee/update-nominee-success";
import EKYC from "./ekycForm";
import SipCancellation from "./sipCancellation";
import NctTypes from "./NctTypes";
import SelectedFolios from "../UpdateNominee/SelectedFolios";

export default class TransactionRouter extends Component {
  render() {
    const { history, location } = this.props;
    return (
      <Switch location={location} history={history}>
        <Route path={`/new-transaction`} exact component={Transactions} />
        <Route
          exact
          path={`/new-transaction/new-investor/ekyc/:pan`}
          component={EKYC}
        />
        <Route exact path={"/new-transaction/nct-types"} component={NctTypes} />
        <Route
          exact
          path={`/new-transaction/transction-types`}
          component={TransactionType}
        />
        <Route
          exact
          path={`/new-transaction/nfo-new-purchase/transaction-modes`}
          component={TransactionMode}
        />
        <Route
          path={`/new-transaction/nfo-new-purchase/digital`}
          component={NFOAndNewPurchaseDigital}
        />
        <Route
          path={`/new-transaction/nfo-new-purchase/physical`}
          component={NFOAndNewPurchaseDigital}
        />
        <Route
          path={`/new-transaction/additional-purchase/physical`}
          component={NFOAndNewPurchaseDigital}
        />
        <Route
          path={`/new-transaction/redemption/physical`}
          component={NFOAndNewPurchaseDigital}
        />
        <Route
          path={`/new-transaction/switch/physical`}
          component={NFOAndNewPurchaseDigital}
        />
        <Route
          path={`/new-transaction/sip/physical`}
          component={NFOAndNewPurchaseDigital}
        />
        <Route
          path={`/new-transaction/stp/physical`}
          component={NFOAndNewPurchaseDigital}
        />
        <Route
          path={`/new-transaction/swp/physical`}
          component={NFOAndNewPurchaseDigital}
        />
        <Route
          exact
          path={`/new-transaction/additional-purchase/transaction-modes`}
          component={TransactionMode}
        />
        <Route
          path={`/new-transaction/additional-purchase/digital`}
          component={NFOAndNewPurchaseDigital}
        />
        <Route
          exact
          path={`/new-transaction/redemption/transaction-modes`}
          component={TransactionMode}
        />
        <Route
          path={`/new-transaction/redemption/digital`}
          component={NFOAndNewPurchaseDigital}
        />
        <Route
          exact
          path={`/new-transaction/switch/transaction-modes`}
          component={TransactionMode}
        />
        <Route
          path={`/new-transaction/switch/digital`}
          component={NFOAndNewPurchaseDigital}
        />
        <Route
          exact
          path={`/new-transaction/sip/transaction-modes`}
          component={TransactionMode}
        />
        <Route
          path={`/new-transaction/sip/digital`}
          component={NFOAndNewPurchaseDigital}
        />
        <Route
          exact
          path={`/new-transaction/swp/transaction-modes`}
          component={TransactionMode}
        />
        <Route
          path={`/new-transaction/swp/digital`}
          component={NFOAndNewPurchaseDigital}
        />

        <Route
          exact
          path={`/new-transaction/stp/transaction-modes`}
          component={TransactionMode}
        />
        <Route
          path={`/new-transaction/stp/digital`}
          component={NFOAndNewPurchaseDigital}
        />

        <Route
          exact
          path={`/new-transaction/sip-cancellation/transaction-modes`}
          component={TransactionMode}
        />
        <Route
          path={`/new-transaction/sip-cancellation/digital`}
          component={NFOAndNewPurchaseDigital}
        />

        <Route
          exact
          path={`/new-transaction/nct-type/transaction-modes`}
          component={TransactionMode}
        />
        <Route
          path={`/new-transaction/nct-type/digital`}
          component={NFOAndNewPurchaseDigital}
        />
        <Route
          path={`/new-transaction/nct-type/phygital`}
          component={NFOAndNewPurchaseDigital}
        />

        <Route
          exact
          path={`/new-transaction/eNACH/transaction-modes`}
          component={TransactionMode}
        />
        <Route
          path={`/new-transaction/eNACH/digital`}
          component={NFOAndNewPurchaseDigital}
        />
        {/* creating temporary route for testing */}
        {/* <Route
          path={`/new-transaction/nct-type/update-nominee`}
          component={Nominee}
        /> */}

        <Route
          path={`/new-transaction/nct-type/nominee-edit`}
          component={SelectedFolios}
        />
        {/* <Route */}
        {/* 	path={`/new-transaction/nct-type/change-idcw`} */}
        {/* 	component={SelectedFolios} */}
        {/* /> */}
        <Route
          exact
          path={`/new-transaction/nct-type/update-ind-nominee`}
          component={UpdateNomineeEdit}
        />
        <Route
          path={`/new-transaction/nct-type/success`}
          component={UpdateNomineeSuccess}
        />
      </Switch>
    );
  }
}
